<script setup lang="ts">
import {computed} from "vue";
import {Phone, PhoneHangUp} from "utruckin-icons";

const props = withDefaults(
    defineProps<{
      item: any
    }>(),
    {}
)

const formattedTime = computed(() => {
  const totalSeconds = Number(props.item.duration) || 0

  const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, '0')
  const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0')
  const seconds = String(totalSeconds % 60).padStart(2, '0')

  return `${hours}:${minutes}:${seconds}`
})
</script>

<template>
  <div class="f-ui-call" :class="item.status === 'missed' || item.status === 'rejected' ? 'error' : ''">
    <template v-if="item.duration">
      <Phone :size="16"/>
      <span>{{ formattedTime }}</span>
    </template>
    <template v-else-if="item.status === 'missed'">
      <PhoneHangUp :size="16"/>
      <span>Missed</span>
    </template>
    <template v-else-if="item.status === 'rejected'">
      <PhoneHangUp :size="16"/>
      <span>Declined</span>
    </template>
  </div>
</template>

<style scoped lang="scss">
.f-ui-call {
  padding: 4px 8px;
  border: 1px solid var(--color-border);
  display: flex;
  align-items: center;
  gap: 6px;
  border-radius: 8px;
  color: var(--color-label);

  span {
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0;
    font-weight: 600;
  }

  &.error {
    color: var(--color-red);
  }
}
</style>